/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="a" fill="#fff">
        <path
          fillRule="evenodd"
          d="M8.126 3a4.002 4.002 0 017.748 0H22a2 2 0 012 2v17a2 2 0 01-2 2H2a2 2 0 01-2-2V5a2 2 0 012-2h6.126z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="currentColor"
        d="M8.126 3v2h1.55l.387-1.501L8.126 3zm7.748 0l-1.937.499L14.324 5h1.55V3zm-5.811.499A2.002 2.002 0 0112 2v-4a6.002 6.002 0 00-5.81 4.501l3.873.998zM12 2a2 2 0 011.937 1.499l3.874-.998A6.002 6.002 0 0012-2v4zm3.874 3H22V1h-6.126v4zM22 5h4a4 4 0 00-4-4v4zm0 0v17h4V5h-4zm0 17v4a4 4 0 004-4h-4zm0 0H2v4h20v-4zM2 22h-4a4 4 0 004 4v-4zm0 0V5h-4v17h4zM2 5V1a4 4 0 00-4 4h4zm0 0h6.126V1H2v4z"
        mask="url(#a)"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 13a3 3 0 100-6 3 3 0 000 6zm-1 1a6 6 0 00-6 6h14a6 6 0 00-6-6h-2z"
        clipRule="evenodd"
      />
    </svg>
  );
});

IconComponent.displayName = 'IconRequestAgentHelp24';

export const IconRequestAgentHelp24: React.FC<ISVGIconProps> = createIcon(IconComponent);
